// 유니크한 키로 사용되는 심벌 정의 모음입니다.
// 심볼은 유니크한 구별자로 사용되며, 이 구별자를 이용해서 함수나 변수를 정의할 때 사용됩니다.

export const isEmpty = Symbol.for('mps.isEmpty');